import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { shared } from '../../../../../constants/NationalAccount';
export var CancelButton = function (_a) {
    var handleClose = _a.handleClose, closeBlurb = _a.closeBlurb;
    return (React.createElement(Button, { variant: "text", onClick: handleClose }, !closeBlurb ? shared.cancel : closeBlurb));
};
export var ConfirmButton = function (_a) {
    var confirmBlurb = _a.confirmBlurb, disabled = _a.disabled, cb = _a.cb;
    return (React.createElement(Button, { variant: "primary", type: "submit", disabled: disabled, onClick: cb }, confirmBlurb));
};
export var ModalButtonGroup = function (_a) {
    var confirmBlurb = _a.confirmBlurb, cancelBlurb = _a.cancelBlurb, handleClose = _a.handleClose, disabled = _a.disabled, cb = _a.cb;
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4 sm:sui-flex-row-reverse" },
        React.createElement("div", { "data-testid": "confirmButtonContainer" },
            React.createElement(ConfirmButton, { confirmBlurb: confirmBlurb, disabled: disabled, cb: cb })),
        React.createElement("div", { "data-testid": "cancelButtonContainer", className: "sui-text-center" },
            React.createElement(CancelButton, { handleClose: handleClose, closeBlurb: cancelBlurb }))));
};
